export default __webpack_public_path__ + "static/media/Kerala_2.b0187200.png";